import React, { useState } from 'react';
import { DownOutlined } from '@ant-design/icons';
import './ndoeUi.css';

/**
 * NdoeFormSection — section de formulaire, repliable (utile pour les longs formulaires
 * produit/commande sur mobile). Peut afficher un numéro d'étape.
 *
 * Props :
 *  - step        : numéro d'étape (optionnel, ex. 1)
 *  - title       : titre de section
 *  - hint        : sous-texte d'aide (optionnel)
 *  - collapsible : rend l'en-tête cliquable (défaut true)
 *  - defaultOpen : ouverte au départ (défaut true)
 *  - children    : contenu de la section
 *  - className
 */
export default function NdoeFormSection({
  step,
  title,
  hint,
  collapsible = true,
  defaultOpen = true,
  children,
  className = '',
}) {
  const [open, setOpen] = useState(defaultOpen);
  const isOpen = collapsible ? open : true;

  const Head = collapsible ? 'button' : 'div';

  return (
    <section className={`ndoe-form-section ${isOpen ? 'is-open' : ''} ${className}`}>
      <Head
        type={collapsible ? 'button' : undefined}
        className="ndoe-form-section__head"
        onClick={collapsible ? () => setOpen((o) => !o) : undefined}
        aria-expanded={collapsible ? isOpen : undefined}
      >
        {step != null ? <span className="ndoe-form-section__step">{step}</span> : null}
        <span className="ndoe-form-section__titles">
          <span className="ndoe-form-section__title">{title}</span>
          {hint ? <span className="ndoe-form-section__hint">{hint}</span> : null}
        </span>
        {collapsible ? <DownOutlined className="ndoe-form-section__chevron" /> : null}
      </Head>
      {isOpen ? <div className="ndoe-form-section__body">{children}</div> : null}
    </section>
  );
}
